// Resolves which agent webhook the chat widget posts to.
//
// vert (message-processing-vercel) is THE default for every org — the modern
// agent runtime with the native web product carousel (more_data.shopify_products),
// per-section prompt channel scoping, per-channel additional-tool gating, and
// correct media_type inference for web sends.
//
// The legacy meta-wati-agent-webhook-copy (mcopy) is no longer used by the
// widget. The send payload + realtime response contract are identical, so this
// is a pure routing default.
const SUPABASE_FN_BASE = "https://zvhwjpeeapujvuudfdps.supabase.co/functions/v1";

export function resolveAgentWebhookUrl(organizationId: string): string {
  return `${SUPABASE_FN_BASE}/message-processing-vercel/${organizationId}`;
}
